import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './detail.css';
import Sidebar from '../../components/SideBar/Sidebar.js';
import { formatDate } from '../../components/common/DateTimeFormatter';
import { hideLoading, showLoading } from '../../store/loading-reducer';
import PropTypes from 'prop-types';
import { shopMonitorSliderTime } from '../../helpers/enums';
import { getNewsByIdEdit } from '../../api/news';
import { useParams } from 'react-router-dom'
import DynamicHTMLRenderer from '../../helpers/dynamicHTMLRenderer';
export default function ShopRetirement({ handleloadinTiming }) {
    const dispatch = useDispatch();
    const [news, setNews] = useState({});
    const { baseId } = useParams();
    const isLoading = useSelector((state) => state.loading);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    useEffect(() => {
        if (baseId > 0) {
            dispatch(showLoading());
            getNewsByIdEdit(baseId).then((response) => {
                let newsResponse = response.data.data;
                setNews(newsResponse);
                dispatch(hideLoading());
                handleloadinTiming(shopMonitorSliderTime.default);
                setIsDataLoaded(true);
            });
        }
        document.title = 'Retirement | CWP Team Connect';
    }, [baseId]);

    useEffect(() => {
        if (isLoading && isDataLoaded) {
            dispatch(hideLoading());
            handleloadinTiming(shopMonitorSliderTime.default);
        }
    }, [isLoading, isDataLoaded]);


    return (
        <div className="monitors-inner">
            <div className="monitors-item retirement-wrap">
                <div className="monitors-header-wrap">
                    <p className="monitors-header-title"></p>
                </div>
                <div className="monitors-item-event-wrap">
                    {news && (
                        <div className="monitors-item-event-item">
                            <div className="monitors-item-event-item-inner retirement-inner">
                                <div className="retirement-item-wrap">
                                    <div className="retirement-item">
                                        <div className="retirement-img-wrap">
                                            <img
                                                src={news?.media?.[0]?.mediaItem?.previewsrc}
                                                alt={news?.media?.[0]?.mediaItem?.altText || "retirement placeholder image"}
                                            />
                                        </div>
                                        <div className="retirement-item-info">
                                            <p className="retirement-date">{news?.publishDate && formatDate(news.publishDate, "MMMM dd, yyyy")}</p>
                                            <p className="retirement-title">{news?.title}</p>
                                            <p className="retirement-desc">{news?.content && DynamicHTMLRenderer(news?.content)}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <Sidebar pageType={"retirement"} />
        </div>
    );
}

ShopRetirement.propTypes = {
    handleloadinTiming: PropTypes.func
};